// 施工実施画面群のルーター。
// index -> 一覧、 new/ -> 新規ウィザード、 :id/ -> 詳細、 :id/edit/ -> 編集ウィザード。

import { Routes, Route, useParams } from "react-router-dom";
import { PageContext } from "../PageContext";
import ConstructionListPage from "./ConstructionListPage";
import ConstructionDetailPage from "./ConstructionDetailPage";
import ExecuteSessionPage from "./ExecuteSessionPage";

type Mode = "new" | "resume";

// "new/" と ":id/edit/" は同じツリー位置に ExecuteSessionPage を描画するため、id の変化だけでは
// React がインスタンスを再利用してしまう(前セッションの state/ref が残留する)。
// セッション識別子(new なら "new"、resume なら id)を key に据えて、セッション切替時に強制 remount する。
function ExecuteSessionRoute({ pageContext, mode }: { pageContext: PageContext; mode: Mode }) {
  const { id } = useParams<{ id?: string }>();
  return <ExecuteSessionPage key={id ?? "new"} pageContext={pageContext} mode={mode} />;
}

export default function ConstructionExecuteRoutes({ pageContext }: { pageContext: PageContext }) {
  return (
    <Routes>
      <Route index element={<ConstructionListPage pageContext={pageContext} />} />
      <Route path="new/" element={<ExecuteSessionRoute pageContext={pageContext} mode="new" />} />
      <Route path=":id/edit/" element={<ExecuteSessionRoute pageContext={pageContext} mode="resume" />} />
      <Route path=":id/" element={<ConstructionDetailPage pageContext={pageContext} />} />
    </Routes>
  );
}
